import { useState } from 'react';
import { useTranslation } from '../../i18n';

// TODO(api): replace with GET /api/v1/brand/examples.
const DEFAULT_EXAMPLES = [
  {
    id: 'ex1',
    platform: 'linkedin',
    captionPl:
      '🏛 Dziedzictwo nie jest tylko zachowywane — jest przeżywane. Dziś w Krakowie pokazaliśmy, jak nowe technologie pozwalają nam wracać do tego, co najcenniejsze. Dziękujemy partnerom za wspólną drogę.',
    likes: 487,
    comments: 42,
    topics: ['Heritage', 'Innovation'],
  },
  {
    id: 'ex2',
    platform: 'instagram',
    captionPl:
      '✨ Dziś zespół spotkał się w ICE Kraków — wymiana idei, nowe pomysły, świeża energia. Dziękujemy @UNESCO_PL i @EuropaNostra za obecność.',
    likes: 312,
    comments: 28,
    topics: ['Heritage', 'Partnership'],
  },
  {
    id: 'ex3',
    platform: 'facebook',
    captionPl:
      '🎓 Z radością ogłaszamy nasz nowy program edukacyjny dla młodych liderów dziedzictwa. Zgłoszenia otwarte do końca miesiąca — szczegóły na stronie.',
    likes: 156,
    comments: 12,
    topics: ['Education', 'Youth'],
  },
];

export function ExamplesTab() {
  const { t } = useTranslation();
  const [examples, setExamples] = useState(DEFAULT_EXAMPLES);

  function remove(id) {
    setExamples((prev) => prev.filter((ex) => ex.id !== id));
  }

  return (
    <div className="tab-page">
      <p className="tab-page__intro">{t('brand.examples.intro')}</p>
      <div className="example-list">
        {examples.map((ex) => (
          <article key={ex.id} className="example-card">
            <div className="example-card__header">
              <span className={`platform-badge platform-badge--${ex.platform}`}>
                {t(`platforms.${ex.platform}`)}
              </span>
              <button
                type="button"
                className="data-table__action data-table__action--danger"
                onClick={() => remove(ex.id)}
                title={t('brand.common.delete')}
                aria-label={t('brand.common.delete')}
              >
                ✕
              </button>
            </div>
            <div className="example-card__caption">{ex.captionPl}</div>
            <div className="example-card__footer">
              <div className="example-card__stats">
                <span>❤️ {t('brand.examples.likes', { count: ex.likes })}</span>
                <span>💬 {t('brand.examples.comments', { count: ex.comments })}</span>
              </div>
              <div className="example-card__topics">
                {ex.topics.map((topic) => (
                  <span key={topic} className="chip chip--terra" style={{ fontSize: '11px' }}>
                    {topic}
                  </span>
                ))}
              </div>
            </div>
          </article>
        ))}
      </div>
      <button type="button" className="button button--ghost" style={{ marginTop: 'var(--space-3)' }}>
        + {t('brand.common.addExample')}
      </button>
    </div>
  );
}
